import { getStorageUrl } from '@/utils/utils';

const GamePanel = ({ slider }) => {
    if (!slider || slider.length === 0) return null;

    const { title, content, background, gamelink, downloadlink } = slider[0];

    return (
        <div className="mainContainer">
            <div
                className="lg:mt-[80px] md:mt-[65px] sm:mt-[50px] mt-[40px] flex items-center justify-center relative border border-white/20 lg:rounded-[40px] md:rounded-[30px] sm:rounded-[25px] rounded-[20px] md:aspect-[16/7] aspect-[14/6]"
                style={{
                    backgroundImage: `url(${getStorageUrl(background)})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center max-w-[758px] w-[90%] mx-auto p-6 rounded-lg">
                    <h3 className="leading-[1] xl:text-[60px] lg:text-[50px] md:text-[30px] text-[24px] font-bold w-full text-white">
                        {title}
                    </h3>

                    <p className="lg:text-[22px] sm:text-[20px] text-[16px] font-medium text-white lg:mt-[24px] md:mt-[20px] mt-[16px] lg:mb-[64px] md:mb-[50px] sm:mb-[40px] mb-[32px]">
                        {content}
                    </p>

                    <div className="flex md:gap-[24px] sm:gap-4 gap-3">
                        <a
                            href={downloadlink}
                            className="lg:py-[19px] md:py-[15px] py-[12px] lg:px-[50px] md:px-[43px] sm:px-[36px] px-[31px] border border-white rounded-full text-white text-[16px]"
                        >
                            حمل اللعبه
                        </a>
                        <a
                            href={gamelink}
                            className="lg:py-[19px] md:py-[15px] py-[12px] lg:px-[50px] md:px-[43px] sm:px-[36px] px-[31px] rounded-full text-white bg-main text-[16px]"
                        >
                            اللعب الآن
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GamePanel;
